var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamestopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 484 484",
    style: {
      enableBackground: "new 0 0 484 484"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FC0000;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 242,
    r: 242
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.8,192.5c-23.1,0-38.9,17.8-38.9,49.3c0,31.6,15.2,49.6,39.2,49.6c21.3,0,34.1-11.9,34.5-30.7h-32.5v-24.1 h63.3v19.1c0,39.8-27.3,64-65.5,64c-42.6,0-71.5-29.7-71.5-77.6c0-49.1,30.8-77.9,70.8-77.9c34.2,0,60.6,21.1,64.7,51h-32.5 C147.4,201,136.3,192.5,119.8,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.4,191c-15.7,0-24.3,7.2-24.3,16.9c-0.2,10.9,10.8,15.7,23.9,18.8l13.6,3.3c26.3,5.9,45.3,19.3,45.4,44.5 c-0.1,27.7-21.8,45.4-58.8,45.4c-36.7,0-60.2-16.9-61-49.7h31c1,15.2,13,22.8,29.6,22.8c16.3,0,26.8-7.5,26.8-18.6 c-0.1-10.2-9.2-14.9-25.7-18.9l-16.5-4.1c-25.6-6.1-41.3-18.9-41.2-41.2c-0.1-27.5,24.2-45.8,57.4-45.8c33.7,0,55.9,18.6,56.3,45.6 h-30.7C284.1,197.9,274.7,191,259.4,191z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.2,166.3h102v26.4h-70v36.1H430v26.4h-64.7v36.1h70.3v26.4H333.2V166.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamestopIcon);
export default __webpack_public_path__ + "static/media/gamestop_icon.5751f655f02f2f2b641f1a6645431935.svg";
export { ForwardRef as ReactComponent };